import { useState } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import { Header } from "@src/components/Header/Header";
import {
  MaxWidthContent,
  UnconnectedPageTemplate,
} from "@endya-conformite/ui-kit";

type ForgotPasswordData = {
  email: string;
};

export type ForgotPasswordOutletContext = {
  data: ForgotPasswordData;
  setData: (data: ForgotPasswordData) => void;
};

export function ForgotPassword() {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState<ForgotPasswordData>({
    email: searchParams.get("email") ?? "",
  });

  return (
    <UnconnectedPageTemplate>
      <Header />
      <MaxWidthContent>
        <Outlet context={{ data, setData }} />
      </MaxWidthContent>
    </UnconnectedPageTemplate>
  );
}
